import request from "@/utils/request";
import "lodash";
import logger from "@/utils/logger";
const config = require("@/../config/config.json");

export async function svc_getCategoryMenu(categoryId) {
	logger(`@services/menuitem - svc_getCategoryMenu`, 5);
	return request(`${config.apiUrl}menu_items?category=${categoryId}`, {
		method: "GET",
	});
}

export async function svc_getAllOutletsMenu(input) {
	logger(`@services/menuitem - svc_getAllOutletsMenu`, 5);
	let { brand } = input;
	return request(`${config.apiUrl}menu_items/menu-quick-edit?brand=${brand}`, {
		method: "GET",
	});
}

export async function svc_getOutletMenu(input) {
	logger(`@services/menuitem - svc_getOutletMenu`, 5);
	let { outlet, brand} = input;
	// console.log("input: ", input);
	return request(`${config.apiUrl}menu_items/menu-quick-edit?outlet=${outlet}&brand=${brand}`, {
		method: "GET",
	});
}

export async function svc_deleteMenuItem(itemId) {
	logger(`@services/menuitem - svc_deleteMenuItem`, 5);
	return request(`${config.apiUrl}menu_items/${itemId}`, {
		method: "DELETE",
	});
}

export async function svc_cloneMenuItem(itemId, toCategoryId) {
	logger(`@services/menuitem - svc_cloneMenuItem`, 5);
	return request(`${config.apiUrl}menu_items/clone/${itemId}?toCategory=${toCategoryId}`, {
		method: "POST",
	});
}

export async function svc_editMenuItemSoldOut(brandId, outletId, soldOut, formData) {
	logger(`@services/menuitem - svc_editMenuItemSoldOut`, 5);
	return request(`${config.apiUrl}menu_items/sold_out?brand=${brandId}&soldOut=${soldOut}${outletId > 0 ? `&outlet=${outletId}` : ""}`, {
		method: "PUT",
		data: formData
	});
}

export async function svc_editOptionItemSoldOut(brandId, outletId, soldOut, formData) {
	logger(`@services/menuitem - svc_editOptionItemSoldOut`, 5);
	return request(`${config.apiUrl}options/sold_out?brand=${brandId}&soldOut=${soldOut}${outletId > 0 ? `&outlet=${outletId}` : ""}`, {
		method: "PUT",
		data: formData
	});
}